import {Mapper} from '@s-ui/domain'

export class FromVehicleCertificationFeaturesListRawDataToVehicleCertificationFeaturesListVOMapper extends Mapper {
  constructor({vehicleCertificationFeatureValueObject, vehicleCertificationFeaturesListValueObject, config}) {
    super()
    this._config = config
    this._vehicleCertificationFeatureValueObject = vehicleCertificationFeatureValueObject
    this._vehicleCertificationFeaturesListValueObject = vehicleCertificationFeaturesListValueObject
  }

  setFeaturesList = ({featuresList}) => {
    this._featuresList = featuresList
    return this
  }

  map = () => {
    const items = this._featuresList.map(({description, iconUrl, title}) =>
      this._vehicleCertificationFeatureValueObject({
        description,
        iconUrl,
        title
      })
    )
    return this._vehicleCertificationFeaturesListValueObject({items})
  }
}
